import React from 'react';
import _ from 'lodash';

import { useNetSuiteSubsidiarySelectFieldQuery } from 'generated/graphql';



export interface INetSuiteSubsidiary {
  id: string;
  displayName: string;
}

export interface IData {
  objects: INetSuiteSubsidiary[];
}

export function useQuery() {
  const queryTuple = useNetSuiteSubsidiarySelectFieldQuery();

  const wrappedTuple = React.useMemo(() => {
    const data: IData = {
      objects: _.map(queryTuple.data?.subsidiaries ?? [], (node): INetSuiteSubsidiary => ({
        id: node.id,
        displayName: node.name
      }))
    };

    return {
      loading: queryTuple.loading,
      data,
      refetch: async () => {
        queryTuple.refetch({});
      }
    };
  }, [queryTuple]);

  return wrappedTuple;
}
